import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { FeatureFlagsService } from "../../../../services/internal-services/feature-flags.service";
import { BaseDiscreteSelectorComponent } from "../../base/discrete-selector/base-discrete-selector.component";
import { GoogleAnalyticsService } from "../../../../../shared/services/google-analytics.service";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-projects-discrete-selector",
  templateUrl: "../projects-timeline.component.html",
  styleUrls: ["../../base/timeline/base-timeline.component.scss"],
  standalone: false,
})
export class ProjectsDiscreteSelectorComponent extends BaseDiscreteSelectorComponent {
  constructor(
    googleAnalyticsService: GoogleAnalyticsService,
    cdr: ChangeDetectorRef,
    flagService: FeatureFlagsService,
  ) {
    super(googleAnalyticsService, cdr, flagService);
  }
}
